import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, {
          color: "primary",
          flat: "",
          app: "",
          dark: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              style: {"position":"absolute"},
              icon: "",
              to: `/`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content"} }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("通知の設定", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_spacer)
          ]),
          _: 1
        }),
        _createVNode(_component_v_container, { fluid: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: '欠席連絡'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.absentInput,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.absentInput) = $event)),
                        _ctx.changeAbsent
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: '送迎変更'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.pickupInput,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pickupInput) = $event)),
                        _ctx.changePickup
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: 'チャット'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.chatInput,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chatInput) = $event)),
                        _ctx.changeChat
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: '新規申請'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.workflowCreateInput,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workflowCreateInput) = $event)),
                        _ctx.changeWorkflowCreate
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: '申請承認'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.workflowApprovedInput,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.workflowApprovedInput) = $event)),
                        _ctx.changeWorkflowApproved
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("div", {
                      class: "d-flex justify-center",
                      textContent: '申請却下'
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.workflowRejectedInput,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.workflowRejectedInput) = $event)),
                        _ctx.changeWorkflowRejected
                      ],
                      items: _ctx.settingList,
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      color: "primary"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.snackbar,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.snackbar) = $event)),
          timeout: _ctx.timeout,
          outlined: "",
          top: "",
          color: "primary"
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "outlined",
              variant: "text",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.snackbar = false))
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode(" × ", -1)
              ]))]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "timeout"])
      ]),
      _: 1
    })
  ]))
}